customElements.get("load-more") || customElements.define("load-more", class extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector("a"), this.buttonText = this.button.textContent, 
    this.section = this.dataset.section || "", this.selectors = [ "[data-grid]", "[data-pagination-next]", "[data-pagination-previous]" ];
  }
  connectedCallback() {
    this.button?.addEventListener("click", this.loadMore.bind(this));
  }
  loadMore(t) {
    t.preventDefault(), t.stopPropagation(), this.classList.add("opacity-50", "cursor-wait"), 
    window.strings.loading && (this.button.textContent = window.strings.loading);
    const e = t.target.dataset.mode?.includes("prev") ? "afterbegin" : "beforeend", n = document.querySelector(`#shopify-section-${this.section}`) || document, o = new URL(t.target.href), s = new URLSearchParams(o.search);
    s.set("section_id", this.section), fetch(`${o.pathname}?${s.toString()}`).then((t => t.text())).then((o => {
      const i = (new DOMParser).parseFromString(o, "text/html");
      [ `[data-load-${t.target.dataset.mode || "next"}]`, ...this.selectors ].forEach((o => {
        const a = n.querySelector(o);
        if (a) {
          const t = i.querySelector(o);
          t ? o.toLowerCase().includes("grid") ? a.insertAdjacentHTML(e, t.innerHTML) : a.innerHTML = t.innerHTML : a.parentNode.removeChild(a);
        }
        history.pushState(Object.fromEntries(s), "", t.target.href), this.button.textContent = this.buttonText;
      }));
    })).catch((e => {
      console.warn(e), location.href = t.target.href;
    })).finally((() => {
      this.classList.remove("opacity-50", "cursor-wait");
    }));
  }
});